import { remoteInvoke } from "@quatico/magellan-client";
// @service({"namespace": "quaweb-noauth"})
export const quaticoAssistentAdvise = async (input, _context, _serialization) => {
    return remoteInvoke({ name: "quaticoAssistentAdvise", data: { input: input }, namespace: "quaweb-noauth" }, _context, _serialization);
};
//# sourceMappingURL=quatico-assistent-advise.js.map